<template>
  <div>
    <!-- 商品详情页根容器(挂牌/竞价交易) -->
    <div class="goods-detail">
      <!-- 顶部区域:商品图文详情 + 下单/报价操作区 -->
      <div class="top">
        <!-- 商品详情子组件:展示图文、价格等,通过 child-event 回传详情数据 -->
        <Particulars @child-event="bindDeatil" ref="detail"></Particulars>
        <!-- 下单/报价操作区:竞价待开始(0)/进行中(1) 或 挂牌中(0) 时显示 -->
        <div
          class="form-box"
          v-if="
            (detailData.tradeBidding && detailData.tradeBidding.biddingStatus == 1) ||
            (detailData.tradeBidding && detailData.tradeBidding.biddingStatus == 0) ||
            (detailData.tradeGoodsListing && detailData.tradeGoodsListing.listingStatus == 0)
          ">
          <!-- 下单/报价表单 -->
          <div class="form">
            <el-form :model="ruleForm" :rules="rules" ref="form" label-width="90px">
              <!-- 挂牌交易:下单数量输入框(加减步进,单位:吨;拆单锁定数量时禁用) -->
              <el-form-item
                label="下单数量"
                label-width="100px"
                prop="num"
                v-if="selectTradeType == 1 && detailData.listType == 0"
                class="offerPrice">
                <i class="el-icon-minus" @click="subNum"></i>
                <el-input
                  :disabled="isinitialCount"
                  v-model="ruleForm.num"
                  maxlength="10"
                  @input="formatData(ruleForm, 'num')"></el-input>
                <i class="el-icon-plus" @click="addNum"></i>
                <span>吨</span>
              </el-form-item>
              <!-- 竞价交易:各商品报价金额列表(按最低价差步进,单位:元/吨) -->
              <div v-for="(item, index) in ruleForm.offerDetailList" :key="index">
                <el-form-item
                  :label="index == 0 ? '报价金额' : ''"
                  :prop="'offerDetailList.' + index + '.offerPrice'"
                  :rules="{
                    required: true,
                    message: '请输入报价金额',
                    trigger: 'blur',
                  }"
                  label-width="150px"
                  v-if="selectTradeType == 2 && detailData.listType == 0"
                  class="offerPrice">
                  <div class="offerPriceItem">
                    <!-- <span class="goodsName">{{ item.goodsName }}</span> -->
                    <i class="el-icon-minus" @click="sub(index)"></i>
                    <el-input
                      v-model="ruleForm.offerDetailList[index].offerPrice"
                      maxlength="10"
                      @input="formatData(ruleForm.offerDetailList[index], 'offerPrice')"></el-input>
                    <i class="el-icon-plus" @click="add(index)"></i>
                    <span>元/吨</span>
                  </div>
                </el-form-item>
              </div>
              <!-- 竞价销售:最低加价提示 -->
              <div
                v-if="selectTradeType == 2 && selectOrderType == 1 && detailData.listType == 0"
                style="margin-left: 160px; color: red">
                <!-- 多商品竞价需要将竞价内所含商品均报价才算报价成功&nbsp;&nbsp;&nbsp;&nbsp; -->
                最低加价{{ detailData.tradeBidding.lowestDiffPrice }}元
              </div>
              <!-- 竞价采购:最低降价提示 -->
              <div
                v-if="selectTradeType == 2 && selectOrderType == 2 && detailData.listType == 0"
                style="margin-left: 160px; color: red">
                <!-- 多商品竞价需要将竞价内所含商品均报价才算报价成功&nbsp;&nbsp;&nbsp;&nbsp; -->
                最低降价{{ detailData.tradeBidding.lowestDiffPrice }}元
              </div>
            </el-form>
          </div>
          <!-- 操作按钮区(按交易类型/保证金/审核状态条件显示) -->
          <div class="btn-wrap">
            <!-- 挂牌销售 → 确认采购 -->
            <el-button
              class="add hy-btn"
              @click="createOrder(2)"
              v-if="selectTradeType == 1 && selectOrderType == 1 && detailData.listType == 0"
              >确认采购</el-button
            >

            <!-- 挂牌采购 → 确认供货 -->
            <el-button
              class="add hy-btn"
              @click="createOrder(1)"
              v-if="selectTradeType == 1 && selectOrderType == 2 && detailData.listType == 0"
              >确认供货</el-button
            >
            <!-- 竞价-已交保证金 → 立即报价 -->
            <el-button
              class="add hy-btn"
              @click="openPayBond(2)"
              v-if="selectTradeType == 2 && detailData.listType == 0 && payBond == 1"
              >立即报价</el-button
            >
            <!-- 竞价-未交保证金(无需审核或审核已通过) → 支付保证金 -->
            <el-button
              class="add hy-btn"
              @click="openPayBond(1)"
              v-if="
                selectTradeType == 2 &&
                detailData.listType == 0 &&
                payBond == 0 &&
                (detailData.tradeBidding.partNeedAudit == 0 ||
                  (detailData.tradeBidding.partNeedAudit == 1 && partAuditStatus == 1))
              "
              >支付保证金</el-button
            >
            <!-- 竞价-需参与审核 → 参与竞价/待审核(待审核时禁用) -->
            <el-button
              class="add hy-btn"
              @click="participateBidding()"
              :disabled="partAuditStatus == 0"
              v-if="
                selectTradeType == 2 &&
                detailData.listType == 0 &&
                payBond == 0 &&
                detailData.tradeBidding.partNeedAudit == 1 &&
                partAuditStatus != 1
              "
              >{{ formatApplyVal }}</el-button
            >
            <!-- 收藏商品 -->
            <el-button
              class="follow"
              icon="el-icon-plus"
              @click="follow"
              v-if="detailData.listType == 0 && detailData.followFlag == 0"
              >收藏商品</el-button
            >
            <!-- 取消收藏 -->
            <el-button
              class="follow"
              icon="el-icon-plus"
              @click="follows"
              v-if="detailData.listType == 0 && detailData.followFlag == 1"
              >取消收藏</el-button
            >
          </div>

          <!-- 距离竞价结束倒计时 -->
          <div v-if="detailData.residueTime && detailData.residueTime != '0'">
            <div style="margin-left: 20px">
              <div
                style="
                  display: flex;
                  align-items: center;
                  margin-bottom: 9px;
                  font-size: 16px;
                  color: #333;
                ">
                <div
                  style="
                    width: 53px;
                    height: 1px;
                    background: #2a8de9;
                    display: inline-block;
                  "></div>
                <div style="margin: 0 5px">距离结束还有</div>

                <div
                  style="
                    width: 53px;
                    height: 1px;
                    background: #2a8de9;
                    display: inline-block;
                  "></div>
              </div>
              <CountDown
                v-if="detailData.residueTime"
                :endDate="`${detailData.residueTime}`"
                @send="sendFun"
                :key="isdata"></CountDown>
            </div>
          </div>

          <!-- 距离竞价开始倒计时 -->
          <div v-if="detailData.distanceStartTime && detailData.distanceStartTime != '0'">
            <div style="margin-left: 20px">
              <div
                style="
                  display: flex;
                  align-items: center;
                  margin-bottom: 9px;
                  font-size: 16px;
                  color: #333;
                ">
                <div
                  style="
                    width: 53px;
                    height: 1px;
                    background: #2a8de9;
                    display: inline-block;
                  "></div>
                <div style="margin: 0 5px">距离开始还有</div>

                <div
                  style="
                    width: 53px;
                    height: 1px;
                    background: #2a8de9;
                    display: inline-block;
                  "></div>
              </div>
              <CountDown
                v-if="detailData.distanceStartTime"
                :endDate="`${detailData.distanceStartTime}`"></CountDown>
            </div>
          </div>
        </div>
        <!-- 交易已结束且商品已收藏:仅保留取消收藏按钮 -->
        <div
          class="form-box"
          style="padding: 20px"
          v-if="
            !(
              (detailData.tradeBidding && detailData.tradeBidding.biddingStatus == 1) ||
              (detailData.tradeBidding && detailData.tradeBidding.biddingStatus == 0) ||
              (detailData.tradeGoodsListing && detailData.tradeGoodsListing.listingStatus == 0)
            ) &&
            detailData.listType == 0 &&
            detailData.followFlag == 1
          ">
          <div class="btn-wrap">
            <el-button class="follow" icon="el-icon-plus" @click="follows">取消收藏</el-button>
          </div>
        </div>
      </div>
      <!-- 竞价交易专属区域 -->
      <div v-if="selectTradeType == 2">
        <!-- 竞价公司报价记录列表(需已登录且企业认证通过;进行中或有中标结果的定向场次仅参与方可见) -->
        <div class="list" v-if="computedLoginAndAuthentication && canSeeOfferRecord">
          <div class="t">
            <div>竞价公司</div>
            <div style="cursor: pointer" @click="flushClick">
              <i class="el-icon-refresh"></i>
            </div>
          </div>
          <el-table
            :data="tableData.list"
            :span-method="objectSpanMethod"
            border
            style="width: 100%">
            <el-table-column align="center" prop="companyName" label="竞价公司"> </el-table-column>
            <el-table-column align="center" prop="goodsName" label="竞价商品名称">
            </el-table-column>
            <el-table-column align="center" prop="offerPrice" label="报价金额"> </el-table-column>
            <el-table-column align="center" prop="offerCount" label="报价数量(吨)">
            </el-table-column>
            <el-table-column prop="createTime" align="center" label="报价时间"> </el-table-column>
            <el-table-column align="center" prop="winBidding" label="中标状态" width="180">
              <template slot-scope="scope">
                <div v-if="scope.row.winBidding == 1">
                  <img src="../../assets/zxx_img/zhongbiao.png" alt="" />
                </div>
                <div v-if="scope.row.winBidding == 0">
                  <div>未中标</div>
                </div>
                <div v-if="scope.row.winBidding == -1">
                  <div>竞价中</div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :total="tableData.total"
            :page-size="search.size"
            :current-page.sync="search.page">
          </el-pagination>
        </div>
        <!-- 审核参与竞价企业(仅发布方且开启参与审核时显示) -->
        <div
          class="list"
          v-if="detailData.ifPublisher && detailData.tradeBidding.partNeedAudit == 1">
          <div class="t">
            <div>审核参与竞价企业</div>
            <div style="cursor: pointer" @click="listPartBidding">
              <i class="el-icon-refresh"></i>
            </div>
          </div>
          <el-table :data="partBiddingData" border style="width: 100%">
            <el-table-column align="center" prop="enterpriseName" label="竞价公司">
            </el-table-column>
            <el-table-column align="center" prop="telephone" label="注册电话"> </el-table-column>
            <el-table-column prop="createTime" align="createTime" label="提交时间">
            </el-table-column>
            <el-table-column align="center" prop="auditStatus" label="状态" width="180">
              <template slot-scope="scope">
                <div v-if="scope.row.auditStatus == 0">
                  <div>待审核</div>
                </div>
                <div v-if="scope.row.auditStatus == 1">
                  <div>审核通过</div>
                </div>
                <div v-if="scope.row.auditStatus == 2">
                  <div>审核拒绝</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="winBidding" label="操作" width="180">
              <template slot-scope="scope">
                <el-button
                  v-if="
                    scope.row.auditStatus == 0 &&
                    (detailData.tradeBidding?.biddingStatus == 0 ||
                      detailData.tradeBidding?.biddingStatus == 1)
                  "
                  @click="Approved(scope.row, 1)"
                  type="text"
                  size="small"
                  >审核通过</el-button
                >
                <el-button
                  v-if="
                    scope.row.auditStatus == 0 &&
                    (detailData.tradeBidding?.biddingStatus == 0 ||
                      detailData.tradeBidding?.biddingStatus == 1)
                  "
                  @click="Approved(scope.row, 2)"
                  type="text"
                  size="small"
                  >审核拒绝</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 竞价规则说明 -->
        <div class="rule">
          <regulation :data="detailData"></regulation>
        </div>
      </div>
      <!-- 商品评价区(暂未启用) -->
      <div class="evaluate">
        <!-- <Evaluate/> -->
      </div>
    </div>
    <!-- <PayBond
      :data="detailData"
      :isShow="paybondShow"
      @close="closeDialog('paybondShow')"
      @paymentSuccess="paymentSuccessFn"
    /> -->

    <!-- 保证金支付弹窗(支付成功后回调刷新详情与保证金状态) -->
    <PaymentBond
      v-bind="$attrs"
      v-on="$listeners"
      :data="config"
      :isShow="paymentBondShow"
      @close="closeDialog('paymentBondShow')"
      @paymentSuccess="paymentSuccessFn" />
    <!-- 竞价公告阅读确认弹窗(首次进入需阅读并勾选确认,禁止 ESC/遮罩关闭) -->
    <el-dialog
      v-if="selectTradeType == 2"
      title=""
      :visible.sync="centerDialogVisible"
      :close-on-press-escape="allFalse"
      :close-on-click-modal="allFalse"
      :show-close="allFalse"
      width="80%"
      center>
      <div class="width_center">
        <!-- 返回上一页按钮 -->
        <div class="go_0" @click="handleGoBack">
          <i class="hy-icon-fanhui" style="color: #4e6ef2; font-size: 18px"></i>
          返回
        </div>
        <!-- 公告标题、发布时间 -->
        <div class="title">{{ inner.messageContent }}</div>
        <div class="data"><i class="hy-icon-shijian1"></i> {{ inner.createTime }}</div>
        <!-- 公告正文(富文本)与附件列表(pdf/word 图标 + 下载链接) -->
        <div class="img" v-if="inner.articleContent">
          <!-- <img 
        style="width: 100%; height: 100%"
        :src="baseUrl+'third/third/ossGetFile/'+inner.messageImg"
      /> -->
          <div v-html="inner.articleContent" class="articlContet"></div>
          <div class="content_all">
            <div v-for="(item, index) in inner.fileList" :key="index">
              <!-- <el-button style="height:60px;line-height: 30px;" @click="examinecontract(item.storageName)">点击下载文件({{item.originalName}}) -->
              <div class="fileListImg">
                <img
                  src="../../assets/img/pdf.png"
                  alt=""
                  v-if="
                    item.storageName.slice(-4) == '.pdf' || item.storageName.slice(-4) == '.PDF'
                  " />
                <img
                  src="../../assets/img/word.png"
                  alt=""
                  v-if="
                    item.storageName.slice(-4) == '.doc' || item.storageName.slice(-5) == '.docx'
                  " />
                <a :href="baseUrl + 'third/third/ossGetFile/' + item.storageName" target="_blank">{{
                  item.originalName
                }}</a>
              </div>
              <!-- </el-button> -->
            </div>
          </div>
        </div>
        <div v-else-if="inner.messageImg" class="img">
          <img
            style="width: 100%; height: 100%"
            :src="baseUrl + 'third/third/ossGetFile/' + inner.messageImg" />
        </div>
      </div>
      <!-- 底部:已阅读勾选 + 参与竞价按钮(未勾选时禁用) -->
      <span slot="footer" class="dialog-footer">
        <div>
          <el-checkbox v-model="checked">我已阅读并接受以上竞价公告所示内容</el-checkbox>
        </div>
        <el-button class="subimt_btn" type="primary" @click="AddConfirm" :disabled="!checked"
          >参与竞价</el-button
        >
      </span>
    </el-dialog>
    <!-- 报名截止提示弹窗(竞价进行中且未确认公告时显示,发布方不弹;禁止 ESC/遮罩/关闭按钮;custom-class 供样式垂直居中) -->
    <el-dialog
      title=""
      :visible.sync="signupClosedDialogVisible"
      :close-on-press-escape="allFalse"
      :close-on-click-modal="allFalse"
      :show-close="allFalse"
      width="520px"
      custom-class="signup-closed-dialog"
      top="auto"
      center>
      <div class="signup-closed-tip">当前竞价已结束报名，无法参与本场次竞价</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="signupClosedDialogVisible = false">查看详情</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  reqFollow,
  reqCreateOrder,
  reqAddBiddingOffer,
  reqIsPayBond,
  reqTradeOfferList,
  reqIsPayBonds,
  applyPartBidding,
  listPartBidding,
  auditPartBidding,
} from "@/api/hy";
import {
  tradeDtetails,
  checkIfConfirm,
  bidNoticeConfirm,
  reqBiddingTargeted,
} from "@/api/public.js";
const { baseUrl } = require("@/config");
import { biddingdetail } from "@/api/home";
import floatCompute from "@/utils/floatCompute.js";
import { number } from "echarts";
import * as types from "@/store/action-types";
import * as ESASignClient from "@/utils/signConfig/ESASignClient.js";
import Vue from "vue";
import { mapState, mapActions } from "vuex";
import { Notification, MessageBox, Message } from "element-ui";
export default {
  data() {
    return {
      /** 接口基础地址(拼接文件/图片访问路径) */
      baseUrl: baseUrl,
      /** 竞价公告详情(标题、正文、附件、时间) */
      inner: {},
      /** 是否勾选"我已阅读并接受竞价公告" */
      checked: false,
      /** 竞价公告确认弹窗显示状态 */
      centerDialogVisible: false,
      /** 报名截止提示弹窗显示状态(竞价进行中且未确认公告时,发布方不弹) */
      signupClosedDialogVisible: false,
      /** 公告弹窗判定是否已执行(详情刷新会重入 bindDeatil,仅首次执行) */
      noticeCheckDone: false,
      /** 固定 false:禁止弹窗 ESC / 点遮罩 / 右上角关闭 */
      allFalse: false,
      /** 倒计时组件 key,自增以强制重建倒计时 */
      isdata: 0,
      /** 是否锁定下单数量(拆单商品固定初始量,不可编辑) */
      isinitialCount: false,
      /** 交易类型(路由参数):1 挂牌,2 竞价 */
      selectTradeType: 0,
      /** 表单数据 */
      ruleForm: {
        /** 下单数量(吨,挂牌交易) */
        num: "",
        /** 竞价报价明细列表(竞价交易,每商品一条) */
        offerDetailList: [],
      },
      /** 表单校验规则 */
      rules: {
        num: [
          {
            required: true,
            message: "请输入可供应数量",
            trigger: "blur",
          },
        ],
        offerPrice: [
          {
            required: true,
            message: "请输入报价金额",
            trigger: "blur",
          },
        ],
      },
      /** 商品详情数据(由 Particulars 子组件回传) */
      detailData: {},
      /** 提交中标记,防止重复提交 */
      submiting: false,
      /** 旧版保证金弹窗显示状态(已废弃未使用) */
      paybondShow: false,
      /** 保证金支付弹窗显示状态 */
      paymentBondShow: this.paymentBondShow,
      /** 保证金支付弹窗配置(金额等,来自接口) */
      config: {},
      /** 报价记录列表分页参数 */
      search: {
        page: 1,
        size: 10,
      },
      /** 报价记录列表数据 */
      tableData: {
        total: 0,
        list: [],
      },
      /** 保证金支付状态:0 未支付,1 已支付 */
      payBond: 0,
      /** 订单类型(路由参数):1 销售,2 采购 */
      selectOrderType: null,
      /** 参与竞价审核状态:-1 未申请,0 待审核,1 已通过 */
      partAuditStatus: null,
      /** 参与竞价企业审核列表数据 */
      partBiddingData: [],
      /** 报价记录是否可见:已出中标结果的定向场次仅参与方可见 */
      canSeeOfferRecord: true,
    };
  },
  computed: {
    ...mapState({
      /** 用户登录/认证状态文案(vuex user 模块) */
      massage: state => state.user.massage,
    }),
    /** 是否已登录且企业认证通过(控制报价记录列表显示) */
    computedLoginAndAuthentication() {
      let status = this.massage == "未登录请前往登录" || this.massage == "请前往认证后操作";
      return !status;
    },
    /** 参与竞价按钮文案:0 → 待审核,其余 → 参与竞价 */
    formatApplyVal() {
      if (this.partAuditStatus == -1) {
        return "参与竞价";
      }
      if (this.partAuditStatus == 0) {
        return "待审核";
      }
      return "参与竞价";
    },
  },
  components: {
    /** 竞价规则说明组件 */
    regulation: () => import("@/layout/regulation.vue"),
    /** 商品图文详情组件(通过 child-event 回传详情数据) */
    Particulars: () => import("@/layout/particulars.vue"),
    /** 旧版保证金弹窗(已停用) */
    PayBond: () => import("./components/payBond.vue"),
    /** 保证金支付弹窗(现行) */
    PaymentBond: () => import("./components/paymentBond.vue"),
    /** 倒计时组件 */
    CountDown: () => import("@/components/countDowns.vue"),
    // Evaluate: () => import("./components/evaluate.vue"),
  },
  /** 初始化:读取路由交易/订单类型,拉取报价列表(公告弹窗判定移至 bindDeatil,需竞价状态) */
  mounted() {
    this.selectTradeType = this.$route.query.selectTradeType;
    this.selectOrderType = this.$route.query.selectOrderType;
    this.getList();
  },
  methods: {
    /** 返回上一页(无历史记录时回首页) */
    handleGoBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push("/index"); // fallback 页面
      }
    },
    /** 根据消息 ID 获取竞价公告详情,并格式化发布时间 */
    getinner(id) {
      biddingdetail({ messageId: id }).then(res => {
        if (res.code == 0) {
          this.inner = res.data;
          console.log("inner", res.data);
          this.inner.createTime = res.data.createTime.replace("T", " ");
        }
      });
    },
    /** 公告弹窗判定:报名中未确认弹公告弹窗;进行中未确认(非发布方)弹报名截止提示;已结束/已流拍/已取消不弹 */
    getConfirm() {
      let config = {
        goodsId: this.$route.query.goodsId,
      };
      checkIfConfirm(config).then(res => {
        if (res.code == 0) {
          // 已确认过公告:任何状态都不弹
          if (res.data.ifConfirm == true) {
            this.centerDialogVisible = false;
            return;
          }
          let status = this.detailData.tradeBidding?.biddingStatus;
          let goodsStatus = this.detailData.goodsStatus;
          // 商品已流拍(2)/已取消(4):不弹任何弹窗,直接查看详情
          if (goodsStatus == 2 || goodsStatus == 4) {
            return;
          }
          // 竞价进行中:报名已截止,未确认公告者提示无法参与(发布方不弹)
          if (status == 1) {
            if (!this.detailData.ifPublisher) {
              this.signupClosedDialogVisible = true;
            }
            return;
          }
          // 已结束(已中标/流拍等):不弹任何弹窗,直接查看详情
          if (status != 0) {
            return;
          }
          // 报名中(待开始):未确认则拉取公告内容并弹窗
          this.getinner(res.data.messageId);
          this.centerDialogVisible = true;
        }
      });
    },
    /** 参与竞价:提交竞价公告确认,成功后关闭公告弹窗 */
    async AddConfirm() {
      const config = { goodsId: this.$route.query.goodsId };
      const res = await bidNoticeConfirm(config);
      if (res.code == 0) {
        this.centerDialogVisible = false;
      } else {
        this.$message.error(res.message || "操作失败");
      }
    },
    /** 倒计时结束回调:重新拉取详情,刷新倒计时 key 与报价列表 */
    sendFun(e) {
      console.log(e, "qqqqqqqqqqqqq5555555555555");
      if (e == 0) {
        tradeDtetails(this.$route.query.goodsId).then(res => {
          if (res.code == 0) {
            this.isdata += 1;
            this.detailData.residueTime = res.data.residueTime;
            this.detailData.tradeBidding.biddingStatus = res.data.tradeBidding.biddingStatus;
            this.getList();
          }
        });
      }
    },
    /** 审核参与竞价企业:type=1 通过,2 拒绝 */
    Approved(row, type) {
      auditPartBidding({
        auditId: row.auditId,
        auditReason: "",
        auditStatus: type,
      }).then(res => {
        if (res.code == 0) {
          this.$message({
            type: "success",
            message: "审核成功",
          });
          this.listPartBidding();
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    /** 获取参与竞价企业的审核列表 */
    listPartBidding() {
      listPartBidding({
        biddingId: this.detailData.tradeBidding.biddingId,
      }).then(res => {
        if (res.code == 0) {
          this.partBiddingData = res.data;
          console.log(res.data, "listPartBidding");
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    /** 参与竞价前置校验：直接读 vuex 的 massage，同步判断"已登录 + 企业认证通过" */
    checkLoginAndAuth() {
      if (this.massage == "未登录请前往登录") {
        // 与全局 beforhandle 保持一致：仅 toast 提示，不弹框不跳转
        this.$message.error(this.massage);
        return false;
      }
      if (this.massage == "请前往认证后操作") {
        MessageBox.confirm("请前往认证后操作", "提示", {
          confirmButtonText: "交易会员认证",
          cancelButtonText: "取消",
          type: "warning",
          customClass: "hy-confirm",
          iconClass: "el-icon-info",
          // distinguishCancelAndClose: true,
        })
          .then(() => {
            this.$router.push("/authentication");
          })
          .catch(action => {
            // 仅点击"中长期会员认证"(cancel)时跳转，右上角关闭/ESC(close)不跳转
            // if (action === "cancel") {
            //   this.$router.push("/MediumTerm");
            // }
          });
        return false;
      }
      return true;
    },
    /** 参与竞价:提交参与申请(待审核状态跳过登录认证校验),成功后刷新详情 */
    async participateBidding() {
      if (this.partAuditStatus !== 0) {
        if (!this.checkLoginAndAuth()) return;
      }
      const res = await applyPartBidding({
        biddingId: this.detailData.tradeBidding.biddingId,
      });
      if (res.code == 0) {
        this.$message({ type: "success", message: "参与成功" });
        this.$refs.detail.getlisst(this.$route.query.goodsId);
      } else {
        this.$message({ type: "error", message: res.message });
      }
    },
    // getPartAuditStatus() {
    //   reqIsPayBond(this.$route.query.goodsId).then((ret) => {
    //     if (ret.code == 0) {
    //       if (ret.data) {
    //         this.partAuditStatus = ret.data.partAuditStatus;
    //       }
    //     } else {
    //       this.$message({
    //         type: "error",
    //         message: ret.message,
    //       });
    //     }
    //   });
    // },
    /** 计算指定字段相同值的连续合并行数(id:字段名,rowIndex:行号) */
    mergeCol(id, rowIndex) {
      // 合并单元格
      // id：属性名
      // rowIndex：行索引值
      var idName = this.tableData.list[rowIndex][id]; // 获取当前单元格的值
      if (rowIndex > 0) {
        // 判断是不是第一行
        // eslint-disable-next-line eqeqeq
        if (this.tableData.list[rowIndex][id] != this.tableData.list[rowIndex - 1][id]) {
          // 先判断当前单元格的值是不是和上一行的值相等
          var i = rowIndex;
          var num = 0; // 定义一个变量i，用于记录行索引值并进行循环，num用于计数
          while (i < this.tableData.list.length) {
            // 当索引值小于table的数组长度时，循环执行
            if (this.tableData.list[i][id] === idName) {
              // 判断循环的单元格的值是不是和当前行的值相等
              i++; // 如果相等，则索引值加1
              num++; // 合并的num计数加1
            } else {
              i = this.tableData.list.length; // 如果不相等，将索引值设置为table的数组长度，跳出循环
            }
          }
          return {
            rowspan: num, // 最终将合并的行数返回
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0, // 如果相等，则将rowspan设置为0
            colspan: 1,
          };
        }
      } else {
        // 如果是第一行，则直接返回
        let i = rowIndex;
        let num = 0;
        while (i < this.tableData.list.length) {
          // 当索引值小于table的数组长度时，循环执行
          if (this.tableData.list[i][id] === idName) {
            i++;
            num++;
          } else {
            i = this.tableData.list.length;
          }
        }
        return {
          rowspan: num,
          colspan: 1,
        };
      }
    },
    /** 表格合并单元格:竞价公司/报价时间/中标状态列按 offerId 合并 */
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0 || columnIndex == 4 || columnIndex == 5) {
        return this.mergeCol("offerId", rowIndex);
      }
    },
    /** 分页页码切换:更新页码并重新拉取报价列表 */
    handleCurrentChange(val) {
      this.search.page = val;
      this.getList();
    },
    /** 报价列表拍平:将每条报价的明细 offerDetailList 展开成行;金额加 ￥ 前缀,0 显示 * */
    formatTableDate(list) {
      if (!list || list.length == 0) {
        return [];
      }
      let newList = [];
      list.forEach(item => {
        item.offerDetailList.forEach(i => {
          if (i.offerPrice == 0) {
            i.offerPrice = "*";
          } else {
            i.offerPrice = "￥" + i.offerPrice;
          }
          newList.push({ ...item, ...i });
        });
      });
      return newList;
    },
    /** 手动刷新报价记录列表(成功后提示) */
    flushClick() {
      reqTradeOfferList({
        ...this.search,
        goodsId: this.$route.query.goodsId,
      })
        .then(ret => {
          if (ret.code == 0) {
            let list = ret.data.records;
            list.forEach(item => {
              item.createTime = item.createTime.replace("T", " ");
              if (item.offerPrice == 0) {
                item.offerPrice = "*";
              }
            });

            this.tableData.list = this.formatTableDate(list);
            this.tableData.total = ret.code == 0 ? ret.data.total : 0;
            this.$message({
              message: "刷新成功",
              type: "success",
            });
          } else {
            this.tableData.list = [];
            this.tableData.total = 0;
          }
        })
        .catch(err => {
          console.log(err);
          this.tableData.list = [];
          this.tableData.total = 0;
        });
    },
    /** 获取报价记录列表,并查询保证金支付状态 */
    /** 校验报价记录可见性:竞价进行中(biddingStatus == 1)或已有中标结果(biddingStatus == 3)时,定向竞价仅参与方可见 */
    checkOfferRecordPermission() {
      let biddingStatus = this.detailData.tradeBidding?.biddingStatus;
      // 非进行中且未出中标结果(未开始/流拍/取消):维持可见
      if (biddingStatus != 1 && biddingStatus != 3) {
        this.canSeeOfferRecord = true;
        return;
      }
      reqBiddingTargeted(this.$route.query.goodsId)
        .then(res => {
          if (res.code != 0) {
            // 接口异常:保守处理,不可见
            this.canSeeOfferRecord = false;
            return;
          }
          /** biddingTargeted 是否定向竞价：0不开启 1开启
           * partiesFlag 是否参与方：0不是 1是
           */
          // 未开启定向竞价:公开可见
          if (res.data.biddingTargeted != 1) {
            this.canSeeOfferRecord = true;
            return;
          }
          // 开启定向竞价:仅参与方可见(企业审核中同样不可见,口径与公告详情侧 beforhandle 一致)
          this.canSeeOfferRecord = res.data.partiesFlag == 1 && this.massage == "";
        })
        .catch(() => {
          // 请求失败:保守处理,不可见
          this.canSeeOfferRecord = false;
        });
    },
    getList() {
      // 步骤一:拉取报价记录(格式化时间,0 报价显示 *,明细拍平成行)
      reqTradeOfferList({
        ...this.search,
        goodsId: this.$route.query.goodsId,
      })
        .then(ret => {
          if (ret.code == 0) {
            console.log(ret.data);
            let list = ret.data.records;
            list.forEach(item => {
              item.createTime = item.createTime.replace("T", " ");
              if (item.offerPrice == 0) {
                item.offerPrice = "*";
              }
            });
            this.tableData.list = this.formatTableDate(list);
            console.log(this.tableData.list);
            this.tableData.total = ret.code == 0 ? ret.data.total : 0;
          } else {
            this.tableData.list = [];
            this.tableData.total = 0;
          }
        })
        .catch(err => {
          console.log(err);
          this.tableData.list = [];
          this.tableData.total = 0;
        });
      // 步骤二:查询保证金支付状态
      reqIsPayBond(this.$route.query.goodsId).then(ret => {
        // console.log(ret);
        if (ret.code == 0) {
          this.payBond = ret.data.payBond;
        }
      });
    },
    /** 保证金支付成功回调:刷新详情与保证金状态 */
    paymentSuccessFn() {
      let id = this.$route.query.goodsId;
      this.$refs.detail.getlisst(id);
      reqIsPayBond(this.$route.query.goodsId).then(ret => {
        // console.log(ret);
        if (ret.code == 0) {
          this.payBond = ret.data.payBond;
        }
      });
    },
    /** 详情子组件回调:初始化 detailData、报价明细默认值、拆单锁定数量、审核列表 */
    bindDeatil(data) {
      console.log("bindDeatil", data);
      // 步骤一:保存详情数据与参与竞价审核状态
      this.detailData = data;
      this.partAuditStatus = this.detailData.tradeBidding.partAuditStatus;
      // 公告/报名截止弹窗判定(依赖竞价状态,详情回传后才能判断;仅首次执行防刷新重入)
      if (this.$route.query.selectTradeType == 2 && !this.noticeCheckDone) {
        this.noticeCheckDone = true;
        this.getConfirm();
      }
      // 校验报价记录可见性(已出中标结果的定向场次仅参与方可见)
      this.checkOfferRecordPermission();
      // 步骤二:竞价交易时,用商品分类列表初始化报价明细(默认取起始价)
      if (this.$route.query.selectTradeType == 2) {
        this.ruleForm.offerDetailList = data.goodsCategoryList.map(item => {
          return {
            categoryId: item.categoryId,
            offerPrice: item.goodsPrice,
            goodsPrice: item.goodsPrice,
            goodsName: item.goodsName,
          };
        });
        console.log(this.ruleForm);
      }

      // 步骤三:拆单商品且有初始数量时,锁定下单数量为初始值
      if (this.detailData.tradeGoodsListing && this.detailData.tradeGoodsListing.ifSplit == 1) {
        if (this.detailData.tradeGoods.initialCount) {
          this.ruleForm.num = this.detailData.tradeGoods.initialCount;
          this.isinitialCount = true;
        }
      }
      // 步骤四:拉取参与竞价企业审核列表
      this.listPartBidding();
    },
    /** 下单数量减 1(浮点安全计算;拆单锁定时禁用,最小为 0) */
    subNum() {
      if (this.isinitialCount) {
        return false;
      }
      this.ruleForm.num = floatCompute.floatSub(+this.ruleForm.num, 1);
      if (this.ruleForm.num <= 0) {
        this.ruleForm.num = 0;
      }
    },
    /** 下单数量加 1(浮点安全计算;拆单锁定时禁用) */
    addNum() {
      if (this.isinitialCount) {
        return false;
      }
      this.ruleForm.num = floatCompute.floatAdd(+this.ruleForm.num, 1);
    },
    /** 报价金额减:竞价销售按最低价差递减且不破起始价;竞价采购下限为 0 */
    sub(index) {
      let data = this.detailData.tradeBidding;
      // 竞价销售(加价型):已到 0 或起始价时不再下调,否则按最低价差递减
      if (this.$route.query.selectTradeType == 2 && this.$route.query.selectOrderType == 1) {
        if (this.ruleForm.offerDetailList[index].offerPrice <= 0) {
          this.ruleForm.offerDetailList[index].offerPrice = 0;
        } else if (
          this.ruleForm.offerDetailList[index].offerPrice ==
          this.ruleForm.offerDetailList[index].goodsPrice
        ) {
          this.ruleForm.offerDetailList[index].offerPrice =
            this.ruleForm.offerDetailList[index].goodsPrice;
        } else {
          this.ruleForm.offerDetailList[index].offerPrice =
            Number(this.ruleForm.offerDetailList[index].offerPrice) - Number(data.lowestDiffPrice);
        }
      } else {
        // 竞价采购(降价型):按最低降价幅度逐步下调,下限 0
        if (this.ruleForm.offerDetailList[index].offerPrice - data.lowestDiffPrice <= 0) {
          this.ruleForm.offerDetailList[index].offerPrice = 0;
        } else if (this.ruleForm.offerDetailList[index].offerPrice <= 0) {
          this.ruleForm.offerDetailList[index].offerPrice = 0;
        } else if (
          this.ruleForm.offerDetailList[index].offerPrice <=
          this.ruleForm.offerDetailList[index].goodsPrice
        ) {
          this.ruleForm.offerDetailList[index].offerPrice =
            Number(this.ruleForm.offerDetailList[index].offerPrice) - Number(data.lowestDiffPrice);
        }
      }
    },
    /** 报价金额加:竞价销售每次加最低价差;竞价采购封顶起始价 */
    add(index) {
      let data = this.detailData.tradeBidding;

      // 竞价销售(加价型):每次加最低加价幅度,无上限
      if (this.$route.query.selectTradeType == 2 && this.$route.query.selectOrderType == 1) {
        this.ruleForm.offerDetailList[index].offerPrice =
          Number(this.ruleForm.offerDetailList[index].offerPrice) + Number(data.lowestDiffPrice);
      } else {
        // 竞价采购(降价型):报价上调封顶为起始价
        if (
          this.ruleForm.offerDetailList[index].offerPrice + data.lowestDiffPrice >=
          this.ruleForm.offerDetailList[index].goodsPrice
        ) {
          this.ruleForm.offerDetailList[index].offerPrice =
            this.ruleForm.offerDetailList[index].goodsPrice;
        } else if (
          this.ruleForm.offerDetailList[index].offerPrice >=
          this.ruleForm.offerDetailList[index].goodsPrice
        ) {
          this.ruleForm.offerDetailList[index].offerPrice =
            this.ruleForm.offerDetailList[index].goodsPrice;
        } else {
          this.ruleForm.offerDetailList[index].offerPrice =
            Number(this.ruleForm.offerDetailList[index].offerPrice) + Number(data.lowestDiffPrice);
        }
      }
    },
    /** 通用弹窗关闭(tag:data 中对应弹窗字段名) */
    closeDialog(tag) {
      this[tag] = false;
    },
    /** 挂牌下单:ro=1 确认供货(采购挂单),ro=2 确认采购(销售挂单) */
    createOrder(ro) {
      // 步骤一:二次确认下单
      this.$confirm("请确认是否下单，确认后无法撤销，请谨慎操作", "提示", {
        confirmButtonText: "确认下单",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // if (!this.beforhandle(["listingPurchase:order", "listingSales:order"]))
          // return;
          // selectTradeType == 1 &&
          //         selectOrderType == 1 &&
          //         detailData.listType == 0

          // 步骤二:埋点权限校验(区分 来源:商品收藏详情页 / 列表页)
          let roe = this.$route.query;
          // 挂牌采购-确认供货
          if (
            roe.selectTradeType == 1 &&
            roe.selectOrderType == 2 &&
            this.detailData.listType == 0 &&
            ro == 1 &&
            roe.title == "挂牌采购"
          ) {
            // personalCenter:goodsCollect:detail:listingPurchase:order
            if (!this.beforhandle("personalCenter:goodsCollect:detail:listingPurchase:order"))
              return;
          } else {
            if (!this.beforhandle("listingPurchase:order")) return;
          }

          // 挂牌销售-确认采购
          if (
            roe.selectTradeType == 1 &&
            roe.selectOrderType == 1 &&
            this.detailData.listType == 0 &&
            ro == 2 &&
            roe.title == "挂牌销售"
          ) {
            // personalCenter:goodsCollect:detail:listingSales:order
            if (!this.beforhandle("personalCenter:goodsCollect:detail:listingSales:order")) return;
          } else {
            if (!this.beforhandle("listingSales:order")) return;
          }
          // 步骤三:表单校验 + 防重复提交,提交下单
          this.$refs.form.validate(valid => {
            if (valid) {
              if (this.submiting) return;
              this.submiting = true;

              reqCreateOrder({
                goodsId: this.$route.query.goodsId,
                num: this.ruleForm.num,
              })
                .then(ret => {
                  if (ret.code == 0) {
                    // 步骤四:下单成功,提示前往"我的订单"查看
                    // this.ruleForm.num = ''
                    // this.$message({
                    //   type: "success",
                    //   message: "操作成功",
                    // });
                    // this.$refs.detail.getlisst();
                    this.$confirm("信息已经提交成功，是否前往我的订单内查看？", "提示", {
                      confirmButtonText: "我的订单",
                      cancelButtonText: "取消",
                      type: "warning",
                      customClass: "hy-confirm",
                      iconClass: "hy-icon-dingdanchenggong",
                    })
                      .then(() => {
                        this.$router.push({
                          path: "/order",
                          query: {
                            title: "订单信息",
                          },
                        });
                      })
                      .catch(() => {
                        console.log(111);
                        // this.$router.back(-1);
                      });
                  } else {
                    this.$message({
                      type: "error",
                      message: ret.message,
                    });
                  }
                  this.submiting = false;
                })
                .catch(err => {
                  console.log(err);
                });
            } else {
              console.log("error submit!!");
              return false;
            }
          });
        })
        .catch(() => {});
    },
    /** 查询保证金支付状态:需缴未缴 → 打开支付弹窗;已缴 → 直接提交报价 */
    getreqIsPayBond() {
      // 已有配置且已缴保证金:直接报价
      if (this.detailData.config && this.detailData.config.payBond == 1) {
        this.biddingOffer();
        return;
      }
      let that = this;
      reqIsPayBond(that.$route.query.goodsId).then(ret => {
        that.detailData.config = ret.data;
        // console.log(ret);
        if (ret.code == 0) {
          this.detailData.sets.forEach(item => {
            // 未缴保证金:打开支付弹窗;已缴:直接报价
            if (ret.data.payBond == 0) {
              that.paymentBondShow = true;
              this.config = ret.data;
            } else {
              this.biddingOffer();
            }
          });
        } else {
          this.$message.error(ret.message);
        }
      }),
        err => {
          console.log(err);
        };
    },
    /** 竞价入口:ro=1 支付保证金,ro=2 立即报价;先做埋点权限校验,再校验交易密码 */
    openPayBond(ro) {
      // 步骤一:埋点权限校验(区分 来源:商品收藏详情页 / 列表页,按交易/订单/按钮类型匹配)
      // if (
      //   !this.beforhandle([
      //     "auctionSale:bond",
      //     "auctionSale:offer",
      //     "biddingPurchase:offer",
      //     "biddingPurchase:bond",
      //   ])
      // )
      //   return;

      let route = this.$route.query;
      // 竞价销售-支付保证金
      if (
        route.selectTradeType == 2 &&
        route.selectOrderType == 1 &&
        this.detailData.listType == 0 &&
        this.payBond == 0 &&
        ro == 1 &&
        route.title == "竞价销售"
      ) {
        if (!this.beforhandle("personalCenter:goodsCollect:detail:auctionSale:bond")) return;
      } else {
        if (
          route.selectTradeType == 2 &&
          route.selectOrderType == 1 &&
          this.detailData.listType == 0 &&
          this.payBond == 0 &&
          ro == 1
        ) {
          if (!this.beforhandle("auctionSale:bond")) return;
        }
      }
      // 竞价销售-立即报价
      if (
        route.selectTradeType == 2 &&
        route.selectOrderType == 1 &&
        this.detailData.listType == 0 &&
        this.payBond == 1 &&
        ro == 2 &&
        route.title == "竞价销售"
      ) {
        if (!this.beforhandle("personalCenter:goodsCollect:detail:auctionSale:offer")) return;
      } else {
        if (
          route.selectTradeType == 2 &&
          route.selectOrderType == 1 &&
          this.detailData.listType == 0 &&
          this.payBond == 1 &&
          ro == 2
        ) {
          if (!this.beforhandle("auctionSale:offer")) return;
        }
      }
      // 竞价采购-支付保证金
      if (
        route.selectTradeType == 2 &&
        route.selectOrderType == 2 &&
        this.detailData.listType == 0 &&
        this.payBond == 0 &&
        ro == 1 &&
        route.title == "竞价采购"
      ) {
        if (!this.beforhandle("personalCenter:goodsCollect:detail:biddingPurchase:bond")) return;
      } else {
        if (
          route.selectTradeType == 2 &&
          route.selectOrderType == 2 &&
          this.detailData.listType == 0 &&
          this.payBond == 0 &&
          ro == 1
        ) {
          if (!this.beforhandle("biddingPurchase:bond")) return;
        }
      }
      // 竞价采购-立即报价
      if (
        route.selectTradeType == 2 &&
        route.selectOrderType == 2 &&
        this.detailData.listType == 0 &&
        this.payBond == 1 &&
        ro == 2 &&
        route.title == "竞价采购"
      ) {
        if (!this.beforhandle("personalCenter:goodsCollect:detail:biddingPurchase:offer")) return;
      } else {
        if (
          route.selectTradeType == 2 &&
          route.selectOrderType == 2 &&
          this.detailData.listType == 0 &&
          this.payBond == 1 &&
          ro == 2
        ) {
          if (!this.beforhandle("biddingPurchase:offer")) return;
        }
      }

      // 步骤二:校验企业是否已设置交易密码
      let id = Vue.ls.get(types.enterpriseId);
      reqIsPayBonds(id).then(ret => {
        // that.detailData.config = ret.data;
        // console.log(ret);
        if (ret.code == 0) {
          // console.log(ret.data);
          // 已设置交易密码:进入保证金校验流程;未设置:提示前往财务中心设置
          if (ret.data) {
            this.getreqIsPayBond();

            // that.paymentBondShow = true;
          } else {
            // this.$message({
            //   type: "error",
            //   message: "请设置交易密码",
            // });
            this.$confirm("暂无设置交易密码, 是否前往设置?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.$router.push("/finance");
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消",
                });
              });
          }
        } else {
          this.$message({
            type: "error",
            message: ret.message,
          });
        }
      });
    },

    /** 提交竞价报价(逐商品 categoryId + offerPrice),成功后刷新报价列表 */
    biddingOffer() {
      // 步骤一:表单校验 + 防重复提交
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.submiting) return;
          this.submiting = true;
          // 步骤二:组装报价明细并提交
          let config = {
            goodsId: this.$route.query.goodsId,
            offerDetailList: this.ruleForm.offerDetailList.map(item => {
              return {
                categoryId: item.categoryId,
                offerPrice: item.offerPrice,
              };
            }),
          };
          reqAddBiddingOffer(config)
            .then(ret => {
              if (ret.code == 0) {
                this.$message({
                  type: "success",
                  message: "报价成功",
                });
                this.getList();
                // tradeDtetails(_this.$route.query.goodsId).then(res=>{
                //   if (res.code == 0){
                //     this.isdata+=1
                //     this.detailData.residueTime=res.data.residueTime
                //   }
                // })
              } else {
                this.$message({
                  type: "error",
                  message: ret.message,
                });
              }
              this.submiting = false;
            })
            .catch(err => {});
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /** 下单数量、报价金额输入框限制 */
    formatData(info, name) {
      info[name] =
        info[name].match(/\d+\.?\d{0,2}/, "") === null
          ? ""
          : info[name].match(/\d+\.?\d{0,2}/, "")[0];
      /** 下单数量 */
      if (name == "num") {
        if (info[name].indexOf(".") < 0) {
          info[name] = info[name].substring(0, 7);
        } else {
          info[name] = info[name].substring(0, 10);
        }
      } else {
        if (info[name].indexOf(".") < 0) {
          info[name] = info[name].substring(0, 5);
        } else {
          info[name] = info[name].substring(0, 8);
        }
      }
    },
    /** 取消收藏:埋点权限校验 + 二次确认后调接口,成功刷新详情 */
    follows() {
      // 步骤一:埋点权限校验(区分 来源:商品收藏详情页 / 列表页,按四种交易类型匹配)
      let route = this.$route.query;
      if (route.selectTradeType == 1 && route.selectOrderType == 2 && route.title == "挂牌采购") {
        if (!this.beforhandle("personalCenter:goodsCollect:detail:listingPurchase:collect")) return;
      } else {
        if (route.selectTradeType == 1 && route.selectOrderType == 2) {
          if (!this.beforhandle("listingPurchase:collect")) return;
        }
      }
      if (route.selectTradeType == 1 && route.selectOrderType == 1 && route.title == "挂牌销售") {
        if (!this.beforhandle("personalCenter:goodsCollect:detail:listingSales:collect")) return;
      } else {
        if (route.selectTradeType == 1 && route.selectOrderType == 1) {
          if (!this.beforhandle("listingSales:collect")) return;
        }
      }
      if (route.selectTradeType == 2 && route.selectOrderType == 1 && route.title == "竞价销售") {
        if (!this.beforhandle("personalCenter:goodsCollect:detail:auctionSale:collect")) return;
      } else {
        if (route.selectTradeType == 2 && route.selectOrderType == 1) {
          if (!this.beforhandle("auctionSale:collect")) return;
        }
      }
      if (route.selectTradeType == 2 && route.selectOrderType == 2 && route.title == "竞价采购") {
        if (!this.beforhandle("personalCenter:goodsCollect:detail:biddingPurchase:collect")) return;
      } else {
        if (route.selectTradeType == 2 && route.selectOrderType == 2) {
          if (!this.beforhandle("biddingPurchase:collect")) return;
        }
      }
      // 步骤二:二次确认后取消收藏
      this.$confirm("是否要取消收藏?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          reqFollow({
            goodsId: this.$route.query.goodsId,
            type: 1,
          }).then(res => {
            if (res.code == 0) {
              this.$message({
                type: "success",
                message: "取消收藏成功!",
              });
              let id = this.$route.query.goodsId;
              this.$refs.detail.getlisst(id);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    /** 收藏商品:埋点权限校验 + 防重复提交,成功后提示并刷新详情 */
    follow() {
      // 步骤一:埋点权限校验(区分 来源:商品收藏详情页 / 列表页,按四种交易类型匹配)
      // if (
      //   !this.beforhandle([
      //     "listingPurchase:collect",
      //     "listingSales:collect",
      //     "auctionSale:collect",
      //     "biddingPurchase:collect",
      //   ])
      // )
      //   return;
      let route = this.$route.query;
      if (route.selectTradeType == 1 && route.selectOrderType == 2 && route.title == "挂牌采购") {
        if (!this.beforhandle("personalCenter:goodsCollect:detail:listingPurchase:collect")) return;
      } else {
        if (route.selectTradeType == 1 && route.selectOrderType == 2) {
          if (!this.beforhandle("listingPurchase:collect")) return;
        }
      }
      if (route.selectTradeType == 1 && route.selectOrderType == 1 && route.title == "挂牌销售") {
        if (!this.beforhandle("personalCenter:goodsCollect:detail:listingSales:collect")) return;
      } else {
        if (route.selectTradeType == 1 && route.selectOrderType == 1) {
          if (!this.beforhandle("listingSales:collect")) return;
        }
      }
      if (route.selectTradeType == 2 && route.selectOrderType == 1 && route.title == "竞价销售") {
        if (!this.beforhandle("personalCenter:goodsCollect:detail:auctionSale:collect")) return;
      } else {
        if (route.selectTradeType == 2 && route.selectOrderType == 1) {
          if (!this.beforhandle("auctionSale:collect")) return;
        }
      }
      if (route.selectTradeType == 2 && route.selectOrderType == 2 && route.title == "竞价采购") {
        if (!this.beforhandle("personalCenter:goodsCollect:detail:biddingPurchase:collect")) return;
      } else {
        if (route.selectTradeType == 2 && route.selectOrderType == 2) {
          if (!this.beforhandle("biddingPurchase:collect")) return;
        }
      }
      // 步骤二:防重复提交,调收藏接口
      if (this.submiting) return;
      this.submiting = true;
      reqFollow({
        goodsId: this.$route.query.goodsId,
        type: 0,
      })
        .then(ret => {
          if (ret.code == 0) {
            this.$confirm("添加收藏成功", "提示", {
              confirmButtonText: "关闭",
              cancelButtonText: "关闭",
              confirmButtonClass: "follow-confirm-btn",
              type: "warning",
              customClass: "hy-confirm follow-confirm",
              iconClass: "hy-icon-guanzhuchenggong",
            })
              .then(() => {
                let id = this.$route.query.goodsId;
                this.$refs.detail.getlisst(id);
              })
              .catch(() => {
                let id = this.$route.query.goodsId;
                this.$refs.detail.getlisst(id);
              });
          } else {
            this.$message({
              type: "error",
              message: ret.message,
            });
          }
          this.submiting = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-link--inner {
  font-size: 14px;
  line-height: 50px;
  height: 50px;
}
.go_0 {
  position: relative;
  top: 20px;
  left: 20px;
  text-align: center;
  line-height: 30px;
  width: 90px;
  height: 34px;
  border: 1px solid #d2d2d2;
  border-radius: 17px;
  font-size: 14px;
  cursor: pointer;
}
.width_center {
  width: 1200px;
  margin: 0 auto;
  background: #ffffff;
}
::v-deep .articlContet {
  width: 70%;
  margin: 0 auto;
  img {
    display: block;
    margin: 0 auto;
  }
}
.img {
  min-height: 500px;
}
.title {
  padding-top: 29px;
  height: 60px;
  font-size: 30px;
  font-weight: 500;
  color: #000000;
  line-height: 35px;
  text-align: center;
}
.data {
  margin-top: 27px;
  height: 35px;
  line-height: 35px;
  background: #f8f8f8;
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
}
.content_all {
  margin: 20px auto;
  background: #f9f9f9;
  width: 70%;
  border: 1px dashed #d2d2d2;
  border-radius: 4px;
}
.fileListImg {
  // text-align: center;
  padding: 10px;
  display: flex;

  // justify-content: center;
  align-items: center;
  img {
    width: 40px;
    height: 40px;
    margin-right: 5px;
  }
}

.goods-detail {
  width: 1200px;
  padding: 25px 20px;
  background: white;
  border: 1px solid #e5e5e5;
  margin: 15px auto;

  &::before,
  &::after {
    display: table;
    content: "";
  }
}

.info {
  flex: 1;
  padding: 20px;
  border: 1px solid #222;
}

.right {
  width: 300px;
  flex-shrink: 0;
  margin-left: 20px;
}

.release-info {
  font-size: 18px;

  .title {
    text-align: center;
    margin-bottom: 30px;
  }

  p {
    font-weight: bold;
    margin-bottom: 10px;
  }
}

.form-box {
  margin-top: 20px;
  background: #f7f7f7;
  display: flex;
  // align-items: center;
  padding-top: 16px;

  .el-input {
    width: 100px;
  }
}

.form-box {
  .btn-wrap {
    .el-button {
      border-radius: 0;
      padding: 0;
      height: 40px;
    }

    .follow {
      padding: 0 5px;
      border-radius: 4px;
      height: 40px;
    }

    .add {
      width: 160px;
      border-radius: 4px;
      height: 40px;
      margin-left: 30px;
      margin-bottom: 16px;
    }
  }
}

.evaluate {
  margin-top: 40px;
}

.offerPrice {
  &::v-deep .el-input__inner {
    height: 40px !important;
    border-radius: 0;
  }

  i {
    display: inline-flex;
    height: 40px;
    width: 40px;
    align-items: center;
    justify-content: center;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    cursor: pointer;
  }
  .offerPriceItem {
    display: flex;
    margin-top: 10px;
    &:first-child {
      margin-top: 0;
    }
    .goodsName {
      display: inline-flex;
      align-items: center;
      border: 1px solid #e5e5e5;
      min-height: 40px;
      width: 120px;
      line-height: 1;
      padding: 0 10px;
      margin-top: 0;
    }
  }

  span {
    display: inline-block;
    margin-left: 5px;
  }
}

.hy-confirm::v-deep .el-message-box__container {
  width: 330px !important;
}

.el-pagination {
  text-align: right;
  margin-top: 10px;
}

.list {
  margin-top: 20px;

  .t {
    border: 1px solid #e5e5e5;
    background: #f7f7f7;
    padding: 14px 22px;
    font-size: 18px;
    display: flex;
    justify-content: space-between;
  }

  .el-table {
    border: 1px solid #ebebeb;
  }
}

.rule {
  margin-top: 20px;
}

.signup-closed-tip {
  text-align: center;
  font-size: 16px;
  color: #333;
  padding: 30px 0 10px;
}

// 报名截止弹窗垂直居中:wrapper 是 fixed 全屏容器,弹窗四边归零+margin:auto 即双轴精确居中
// 不用 transform,避免与 dialog-fade 进出场动画的 translate3d 冲突
// 模板须带 top="auto":top prop(默认 15vh)会以内联样式写 margin-top,内联优先级高于此处 margin:auto
::v-deep .signup-closed-dialog {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 520px;
  height: fit-content;
}
</style>
<style>
.hy-icon-dingdanchenggong + .el-message-box__message {
  margin-right: 10px;
}

.hy-icon-dingdanchenggong {
  font-size: 40px !important;
  display: inline-block;
  color: #5a9bf2;
}

.hy-icon-guanzhuchenggong {
  font-size: 30px !important;
  display: inline-block;
  margin-right: 10px;
}
.subimt_btn {
  width: 20%;
  line-height: 30px;
  background: linear-gradient(90deg, #2079fb, #4cb2fc);
  color: #fff;
  font-size: 16px;
  text-align: center;
  border-radius: 2px;
  margin-top: 22px !important;
  margin-bottom: 60px;
}
</style>
